/**
 * @file index.tsx
 *
 * @fileoverview Renders a blog article breadcrumbs.
 */
import { BlogPost } from '~/jobiqo/models/blog';
import { useIntl } from 'react-intl';
import Breadcrumbs from '~/jobiqo/components/Breadcrumbs';

interface BlogBreadcrumbsProps {
  /**
   * The blog article.
   */
  blog: BlogPost;
}

export default function BlogBreadcrumbs({ blog }: BlogBreadcrumbsProps) {
  const intl = useIntl();
  // Remove blog name from path,
  // e.g /blog/management/should-you-become-manager -> /blog/management
  let blogCategoryPath = blog.url.path.split('/').slice(0, -1).join('/');

  let BlogBreadCrumbsItems = [
    {
      label: intl.formatMessage({
        id: 'blog_breadcrumbs_blog',
        defaultMessage: 'Blog',
      }),
      path: '/blog',
    },
  ];

  if (blog.category.label) {
    BlogBreadCrumbsItems.push({
      label: blog.category.label,
      path: blogCategoryPath,
    });
  }

  BlogBreadCrumbsItems.push({
    label: blog.title,
    path: blog.url.path,
  });

  return <Breadcrumbs items={BlogBreadCrumbsItems} />;
}
export { BlogBreadcrumbs };
